import { render, staticRenderFns } from "./SystemSettingConfig.vue?vue&type=template&id=449bb2b0&scoped=true"
import script from "./SystemSettingConfig.vue?vue&type=script&lang=js"
export * from "./SystemSettingConfig.vue?vue&type=script&lang=js"
import style0 from "./SystemSettingConfig.vue?vue&type=style&index=0&id=449bb2b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bb2b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449bb2b0')) {
      api.createRecord('449bb2b0', component.options)
    } else {
      api.reload('449bb2b0', component.options)
    }
    module.hot.accept("./SystemSettingConfig.vue?vue&type=template&id=449bb2b0&scoped=true", function () {
      api.rerender('449bb2b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SystemSettingConfig.vue"
export default component.exports